import { AppBar } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { useGetIdentity } from 'ra-core'
import MenuIcon from '@mui/icons-material/Menu'

import { Box, Typography } from '@mui/material'

import {
  NovuProvider,
  PopoverNotificationCenter,
  NotificationBell,
} from '@novu/notification-center'

import { useNavigate } from 'react-router-dom'
import config from '../config'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import RealtimeNotificationAlert from '../common/Notifications/RealtimeNotificationAlert'
import NotificationPermission from '../common/Notifications/NotificationPermission'
import { IconButton } from '@material-ui/core'
import clsx from 'clsx'
import { useSidebarState } from 'react-admin'

const useStyles = makeStyles((theme) => ({
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  spacer: {
    '&:hover': {
      color: 'lightgrey',
    },
  },
  menuButton: {
    transition: 'transform 0.3s',
    marginLeft: theme.spacing(1),
  },
  menuButtonOpen: {
    transform: 'rotate(90deg)',
  },
  label: {
    marginLeft: theme.spacing(1),
    color: 'white',
    fontWeight: '500',
    cursor: 'pointer',
  },
}))

const NotificationCenter = () => {
  const navigate = useNavigate()
  const { isLoading, identity } = useGetIdentity()

  if (!identity) return null
  function onActionClick(templateIdentifier, type, message) {
    if (type === 'primary') {
      navigate(message.cta.data.url)
    }
  }
  const handleBellClick = () => {
    toast.dismiss()
  }

  return (
    <>
      <NovuProvider
        subscriberId={`${identity.id}`}
        applicationIdentifier={config.NOVU_APP_ID}
        i18n="fr"
        initialFetchingStrategy={{
          fetchNotifications: true,
          fetchUnseenCount: true,
        }}
      >
        <PopoverNotificationCenter
          onActionClick={onActionClick}
          colorScheme={'light'}
        >
          {({ unseenCount }) => (
            <div onClick={handleBellClick}>
              <NotificationBell unseenCount={unseenCount} />
            </div>
          )}
        </PopoverNotificationCenter>
        <RealtimeNotificationAlert />
        <NotificationPermission userId={identity?.id} />
      </NovuProvider>
      <ToastContainer autoClose={false} draggable={false} />
    </>
  )
}

const CustomAppBar = ({ ...props }) => {
  const classes = useStyles()
  const [openSidebar, setSidebarOpen] = useSidebarState()

  const handleMenuClick = () => {
    setSidebarOpen(!openSidebar)
  }

  return (
    <AppBar elevation={0} color="primary">
      <IconButton
        edge="start"
        className={clsx(classes.menuButton, {
          [classes.menuButtonOpen]: !openSidebar,
        })}
        color="inherit"
        aria-label="menu"
        onClick={handleMenuClick}
      >
        <MenuIcon />
      </IconButton>
      <Typography
        variant="body1"
        className={classes.label}
        onClick={handleMenuClick}
      >
        Menu
      </Typography>
      <Box component="span" sx={{ flex: 1 }} />
      <Typography variant="h6" color="inherit" id="react-admin-title" />
      <Box component="span" sx={{ flex: 1 }} />
      <NotificationCenter />
    </AppBar>
  )
}

export default CustomAppBar
